import { passthrough } from './passthrough'

export const primeReactConfig = {
  unstyled: true,
  pt: passthrough,
}

export { passthrough }
